
export interface PlatformScreenshot {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  category: 'dashboard' | 'banking' | 'documents' | 'tasks' | 'decisions';
}

export const platformScreenshots: PlatformScreenshot[] = [
  {
    id: 'budget-management',
    title: 'Budget Management',
    description: 'Create and manage annual budgets for your property',
    imageUrl: '/lovable-uploads/da6147cf-037e-4b32-853d-69b3356945e4.png',
    category: 'documents'
  },
  {
    id: 'service-charges',
    title: 'Service Charge Accounts',
    description: 'View your service charge account transactions and summaries',
    imageUrl: '/lovable-uploads/4d7a02e4-0072-4ad3-b5d5-4824f66aff99.png',
    category: 'banking'
  },
  {
    id: 'banking-transactions',
    title: 'Bank Connection & Transaction History',
    description: 'Connect your bank account and review transactions with real-time sync',
    imageUrl: '/lovable-uploads/37034987-b803-458d-9ae1-21909be16814.png',
    category: 'banking'
  },
  {
    id: 'task-manager',
    title: 'Task Manager',
    description: 'Organise, prioritise, and track tasks agreed between the leaseholders',
    imageUrl: '/lovable-uploads/263a0b0a-7c16-4564-96ad-03ddad27c662.png',
    category: 'tasks'
  }
];
